import { createContext } from 'react';

export type AddExpenseFormModalContextProps = {
  propertyId: string | null;
  contractId: string | null;
  incidentId: string | null;
  isOpen: boolean;
  openModal: (propertyId: string, options?: { contractId?: string; incidentId?: string }) => void;
  closeModal: () => void;
};

export const AddExpenseFormModalContext = createContext<AddExpenseFormModalContextProps>({
  propertyId: null,
  contractId: null,
  incidentId: null,
  isOpen: false,
  openModal: () => {},
  closeModal: () => {},
});

